import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { orderAPI } from '../../utils/api';

export default function OrderConfirmPage() {
  const { id } = useParams();
  const { data, isLoading, isError } = useQuery({
    queryKey: ['order-confirm', id],
    queryFn: () => orderAPI.getOne(id).then((res) => res.data),
  });

  if (isLoading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (isError || !data) return (
    <div className="page-container" style={{ paddingTop: 80, paddingBottom: 80, textAlign: 'center' }}>
      <p style={{ color: 'var(--text-light)', marginBottom: 16 }}>Porosia nuk u gjet.</p>
      <Link to="/shop" className="btn btn-primary">Kthehu te Dyqani</Link>
    </div>
  );

  const order = data;
  const shipping = typeof order.shipping_address === 'string' ? JSON.parse(order.shipping_address) : order.shipping_address;

  return (
    <div className="page-container" style={{ paddingTop: 80, paddingBottom: 80 }}>
      <div style={{ marginBottom: 24 }}>
        <Link to="/shop" className="btn btn-ghost">← Vazhdoni të blini</Link>
      </div>

      <div className="order-confirm-card">
        <div className="order-confirm-hero">
          <div>
            <h1>Faleminderit për porosinë!</h1>
            <p className="page-sub">Porosia juaj është pranuar dhe po përpunohet.</p>
          </div>
          <div className="order-status">
            <strong>Nr. Porosisë</strong>
            <span>{order.order_number}</span>
          </div>
        </div>

        <div className="order-grid">
          <div className="order-box">
            <h2 className="section-title">Përmbledhja</h2>
            <div className="summary-row"><span>Totali</span><strong>${Number(order.total).toFixed(2)}</strong></div>
            <div className="summary-row"><span>Pagesa</span><span>{order.payment_method === 'cod' ? 'Në dorëzim' : 'Kartë'}</span></div>
            <div className="summary-row"><span>Statusi</span><span>{order.status}</span></div>
            <div className="summary-row"><span>Pagesa</span><span>{order.payment_status === 'paid' ? 'E paguar' : 'E papaguar'}</span></div>
          </div>

          <div className="order-box">
            <h2 className="section-title">Adresa e dërgimit</h2>
            <p>{shipping.full_name}</p>
            <p>{shipping.address}</p>
            <p>{shipping.city}, {shipping.postal_code}</p>
            <p>{shipping.country}</p>
            <p>{shipping.phone}</p>
          </div>
        </div>

        <div className="order-items-card">
          <h2 className="section-title">Produkte të porositura</h2>
          <div className="checkout-items">
            {order.items.map((item) => (
              <div key={item.id} className="checkout-item-row">
                <img src={item.product_image || 'https://via.placeholder.com/80'} alt={item.product_name} />
                <div>
                  <div style={{ fontWeight: 600 }}>{item.product_name}</div>
                  <div style={{ color: 'var(--text-light)', fontSize: '.85rem' }}>{item.quantity} x ${Number(item.price).toFixed(2)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .order-confirm-card { background: white; border-radius: var(--radius-xl); border: 1px solid var(--cream-dark); padding: 32px; }
        .order-confirm-hero { display: flex; justify-content: space-between; align-items: center; gap: 24px; flex-wrap: wrap; margin-bottom: 32px; }
        .order-confirm-hero h1 { font-size: 2.2rem; margin: 0; }
        .order-status { background: var(--green-soft); padding: 20px; border-radius: var(--radius-xl); text-align: right; min-width: 220px; }
        .order-status strong { display: block; margin-bottom: 8px; color: var(--green-deep); }
        .order-status span { font-size: 1rem; font-weight: 700; }
        .order-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 24px; margin-bottom: 28px; }
        .order-box { background: var(--cream); border-radius: var(--radius-xl); padding: 24px; }
        .order-box h2 { margin-top: 0; }
        .summary-row { display: flex; justify-content: space-between; gap: 8px; margin-bottom: 14px; }
        .order-items-card { background: var(--cream); border-radius: var(--radius-xl); padding: 24px; }
        .checkout-items { display: flex; flex-direction: column; gap: 16px; }
        .checkout-item-row { display: flex; gap: 12px; align-items: center; }
        .checkout-item-row img { width: 72px; height: 72px; object-fit: cover; border-radius: var(--radius-md); background: var(--white); }
        @media(max-width: 860px) { .order-grid { grid-template-columns: 1fr; } }
      `}</style>
    </div>
  );
}
